module.exports = __webpack_public_path__ + "img/new_index_cases.e02da347.png";